import {React} from 'external/react'
import {MenuItem, styled} from 'external/material'
import ClearableSelect from 'components/clearable-select'

const Field = styled('div')({minWidth:0, width:'100%', '& .MuiFormControl-root':{width:'100%', minWidth:0}})
const Status = styled('div')(({theme}) => ({fontSize:12, color:theme.palette.text.secondary, marginTop:theme.spacing(0.5)}))

export default function FilterSelect ({entity, field, label, value, dataset = {}, onChange, onRetry}) {
  const {items = [], status} = dataset
  return <Field>
    <ClearableSelect id={'selector-' + entity} caption={label} value={value || ''}
      onChange={event => onChange(field, event.target.value)} onClear={() => onChange(field, undefined)}>
      {items.map(item => <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>)}
    </ClearableSelect>
    {status === 'loading' && <Status role="status">Cargando…</Status>}
    {status === 'empty' && <Status>Sin resultados</Status>}
    {status === 'error' && <Status role="alert">No se pudo cargar {label.toLowerCase()}. <button type="button" onClick={() => onRetry(entity)}>Reintentar</button></Status>}
  </Field>
}
